export default "__VITE_ASSET__B3tP7X0O__"